module.exports = __webpack_public_path__ + "img/logo-astanet.435aced2.png";